import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import logoCasino from "../assets/img/casino.png";
import logoApeiro from "../assets/img/apeiro.png";

export default function History() {
  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Lore ERI | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="history" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Universo ERI</h1>
          <p className="subtitle">Dos caras de la misma moneda. Ni el malo es tan malo, ni el bueno es tan bueno.</p>
        </div>
        <div className="content-main">
      
        <div className="cards">
          <div class="card-container">
            <div class="card">
              <div class="card-front">
                <img src={logoApeiro} alt="Logo Apeiro"/>
              </div>
              <div class="card-back">
                <div class="card-text">
                  <p>Una misteriosa organización científica en cuyo interior suceden cosas horribles.</p>
                  <p>Es imposible huir de ellos una vez se interesan por ti.</p>
                  <p>Siete sectores.<br/>Siete líderes.<br/>Un objetivo.</p>
                </div>
              </div>
            </div>
            <p class="card-title">Apeiro</p>
          </div>

          <div class="card-container">
            <div class="card">
              <div class="card-front">
                <img src={logoCasino} alt="Logo Casino"/>
              </div>
              <div class="card-back">
                <div class="card-text">
                  <p>Un casino donde un grupo de individuos colaboran por diferentes razones para vengar los crímenes de Apeiro.</p>
                  <p>Cuatro casas, pero…<br/>¿tres líderes?</p>
                </div>
              </div>
            </div>
            <p class="card-title">La Apuesta Imposible</p>
          </div>

        </div>
        <div class="description">
          <p>Descubre la verdad tras estos dos eternos rivales leyendo nuestras novelas.<br/>
          Saga en proceso, ¡podrás disfrutar de las nuevas tramas y comentarlas con otros seguidores!<br/>
          También puedes crear tu propio personaje y enfrentarte a otros jugadores en nuestros eventos en vivo ambientados en este universo.<br/>
          ¿Serás un héroe o un villano? ¿El asesino o la víctima?
          </p>
          <div class="link">
            <a class="btn btn-primary" href="/proyectos">Nuestros proyectos</a>
          </div>
        </div>
        </div>
      </div>
    </div>
  </>
  );
}
